const StatCounter = ({ value, label, icon: Icon, accent = 'cyan', className = '' }) => {
  const accentMap = { cyan: 'text-cyan', violet: 'text-violet', gold: 'text-gold', success: 'text-success' };
  return (
    <div className={`text-center ${className}`}>
      {Icon && <Icon className={`w-5 h-5 mx-auto mb-2 ${accentMap[accent]}`} />}
      <div className={`font-heading font-bold text-2xl lg:text-3xl ${accentMap[accent]} tabular-nums`}>{value}</div>
      <div className="font-mono text-[10px] text-steel-muted uppercase tracking-wider mt-1">{label}</div>
    </div>
  );
};

export default StatCounter;
